import TYPES from './types';
import { apiClientWithToken, downloadExcelFile, downloadFile } from '../services/backend';
import fileDownload from 'js-file-download';

export const fetchDiplomas = (filter) => {
    return async (dispatch) => {
        try {
            
            const res = await apiClientWithToken().get(
                '/diplomas', { params: { ...filter } }
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                dispatch(setDiplomas(data));
                return { ok: true, message: data.message }
            } else {
                return { ok: false, message: data.message };
            }

        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' }
        }
    };
};

const setDiplomas = (data) => ({
   type: TYPES.SET_DIPLOMAS, payload: data
});

export const downloadExcel = (filter) => {
    return async () => {
        try {

            const res = await downloadExcelFile(
                '/diplomas/excel', 
                'diplomas.xlsx',
                filter, {
                    ciudad: 'Diplomas',
                    diplomas_tipo_id: 'Diplomas'
                }
            );
            const blob = await res.blob();
            fileDownload(blob, 'diplomas.xlsx');

            return { ok: true };
    
        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const download = (id) => {
    return async () => {
        try {

            const res = await downloadFile(
                `/diplomas/descargarDiplomas/${ id }`, 
                `diplomas-${id}.pdf`
            );
            const blob = await res.blob();
            fileDownload(blob, `diplomas-${id}.pdf`);

            return { ok: true };
    
        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const selectDiploma = (data) => ({
    type: TYPES.SELECT_DIPLOMA, payload: data
});

export const setDiplomaFilter = (filter) => ({
    type: TYPES.SET_DIPLOMA_FILTER, payload: filter
});

export const deleteDiploma = (id) => {
    return async () => {
        try {
            
            const res = await apiClientWithToken().delete(
                `/diplomas/${id}`
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, message: data.message };
            } else {
                return { ok: false, message: data.message };
            }

        } catch(error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const sendDiploma = (diploma) => {
    return async () => {
        try {
            let res;

            if (diploma.Diplomas.id) {
                res = await apiClientWithToken().put(
                    `/diplomas/${diploma.Diplomas.id}`,
                    diploma
                );
            } else {
                res = await apiClientWithToken().post(
                    '/diplomas', diploma
                );
            }
            
            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, message: data.message };
            } else {
                return { ok: false, message: data.message };
            }

        } catch(error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};